export default {
  title: "Title",
  title_performed_work: "Performed Work",
  subtitle_corrective_work: "<span class='text-info text-bold'>Corrective Work </span>",
  subtitle_regular_work: "<span class='text-info text-bold'>Regular Work </span>",
  subtitle_adhoc_performed_corrective_work: "Performed Corrective Work, Ad-hoc",
  subtitle_adhoc_performed_regular_work: "Performed Regular Work, Ad-hoc",
  subtitle_planned_performed_corrective_work: "Performed Corrective Work, Planned",
  subtitle_planned_performed_regular_work: "Performed Regular Work, Planned",
  tab_work: "Work",
  tab_item: "Item",
  tab_attached: "Attached",
  tab_comments: "Comments",
  label_location: "Location",
  label_issue: "Issue",
  label_designation: "Designation",
  label_isolation: "Isolation",
  label_shutdown: "Shutdown",
  label_issue_description: "Issue description",
  label_work_domain: "Work domain",
  label_work_instructions: "Work Instructions",
  label_work_order: "Work Order",
  label_perform_work: "Perform Work",
  label_performed_work: "Performed Work",
  label_procedure: "Procedure",
  placeholder_title_work: "Title and Work Statement",
  label_corrective_action: "Corrective Action",
  label_time_requirement: "Time requirements",
  label_material_requirement: "Material requirements",
  label_additional_requirement: "Additional requirements",
  separator_correction_info: "Correction Information",
  error_mandatory_fields: "Fill in mandatory fields",
  error_saving_images: "There was a problem saving the images. We're already handling it.",
  regular_work: "Regular Work",
  corrective_work: "Corrective Work",
  label_performed: "Performed",
  label_reference: "Reference",
  label_date: "Date",
  label_by: "By",
  label_item: "Item",
  label_raised_issues: "Raised Issues",
  create_ad_hoc_corrective_work: "Create Ad-Hoc Corrective Work",
  create_ad_hoc_regular_work: "Create Ad-Hoc Regular Work",
  create_planned_corrective_work: "Create Planned Corrective Work",
  create_planned_regular_work: "Create Planned Regular Work",
}
